module.exports = __webpack_public_path__ + "static/media/37.756adb7d.png";